<template>
  <router-link :to="to">
    <slot />
  </router-link>
</template>
<script>
import { QUESTIONS_URL } from '@/modules/question/question.constants';

export default {
  name: 'DaraQuestionLink',
  props: {
    id: {
      type: String,
      required: true,
    },
    action: {
      type: String,
      default: 'view',
      validator(action) {
        return action && ['view', 'edit'].includes(action);
      },
    },
  },
  computed: {
    to() {
      return {
        name: QUESTIONS_URL[this.action].name,
        path: QUESTIONS_URL[this.action].path,
        params: {
          id: this.id,
        },
      };
    },
  },
};
</script>
